import { glnUrl } from '../utils/apiUtils'

const METIERS = ['poissonnerie', 'boucherie']
const jsonHeaders = { 'Content-Type': 'application/json' }

// 200 : le magasin existe dans cet univers ; 404 : il n'y existe pas ; autre : service en panne
const getStore = (metier, idNotion) => {
  return fetch(glnUrl(metier, idNotion), { method: 'GET' })
    .then((res) => {
      if (res.status === 200) {
        return res.json().then((store) => ({ ...store, metier }))
      }
      return res.status === 404 ? null : { metier, unavailable: true }
    })
    .catch(() => ({ metier, unavailable: true }))
}

const saveStore = (metier, idNotion, gln) => {
  return fetch(glnUrl(metier, idNotion), {
    method: 'PUT',
    headers: jsonHeaders,
    body: JSON.stringify({ gln })
  })
    .then((res) => ({ metier, saved: res.status === 200 }))
    .catch(() => ({ metier, saved: false }))
}

export default {
  get: function (idNotion) {
    return Promise.all(METIERS.map((metier) => getStore(metier, idNotion)))
      .then((stores) => stores.filter((store) => store !== null))
  },
  save: function (idNotion, metiers, gln) {
    return Promise.all(metiers.map((metier) => saveStore(metier, idNotion, gln)))
  },
  getOne: function (metier, idNotion) {
    return getStore(metier, idNotion)
  },
  saveOne: function (metier, idNotion, gln) {
    return saveStore(metier, idNotion, gln)
  }
}
